import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { clsx } from 'clsx';

interface LegalLinksProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onClose?: () => void;
  t: any;
}

export function LegalLinks({ isOpen, setIsOpen, onClose, t }: LegalLinksProps) {
  const legalLinks = [
    { path: '/legal/mentions', name: t.legal },
    { path: '/legal/cgu', name: t.terms },
    { path: '/legal/privacy', name: t.privacy },
    { path: '/legal/forum-rules', name: t.rules },
    { path: '/legal/cookies', name: t.cookies }
  ];

  return (
    <div className="px-3 py-3">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full px-3 py-2 text-xs font-medium text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-50 transition-colors"
      >
        <span>{t.legal}</span>
        <ChevronDown className={clsx(
          'h-3.5 w-3.5 transition-transform duration-200',
          isOpen && 'rotate-180'
        )} />
      </button>
      {isOpen && (
        <div className="mt-1 space-y-0.5 pl-1">
          {legalLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={onClose}
              className="block px-3 py-1.5 text-xs text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-50 transition-colors"
            >
              {link.name}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
